import { useMutation } from "@tanstack/react-query";

import { updateSchedulingMethods } from "../api/schedulingMethods";

export const useUpdateSchedulingMethods = () => {
  return useMutation({
    mutationFn: updateSchedulingMethods,
  });
};
